import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguagesListState, LanguageType } from './types';
import { languages } from '@/Pages/Account/constants';

const initialState: LanguagesListState = {
  value: languages,
};

export const languagesListSlice = createSlice({
  name: 'languagesList',
  initialState,
  reducers: {
    setLanguagesList: (state, action: PayloadAction<LanguageType[]>) => {
      state.value = action.payload;
    },
  },
});

export const { setLanguagesList } = languagesListSlice.actions;

// FIX: Selector handles ImmutableJS root state
export const selectLanguagesList = (state: any) => {
  // If state is Immutable Map (has .get), use it. Otherwise assume plain JS.
  const slice = state.get ? state.get('languagesList') : state.languagesList;
  return slice ? slice.value : languages;
};

export default languagesListSlice.reducer;